export default "__VITE_ASSET__be96c3e6__"